import { defaultTheme } from './default'
import { quickswapTheme } from './quickswap'
import { ThemePackage } from './types'

// @ts-ignore
const isNumber = (str: string) => !isNaN(str) && !isNaN(parseFloat(str))
const kebabCase = (str: string) => {
    return str
        .split('')
        .map((letter, idx) => {
            if (isNumber(letter)) {
                const prev = str[idx - 1]
                const prefix = isNumber(prev) ? '' : '-'
                return `${prefix}${letter}`
            }
            return letter.toUpperCase() === letter
                ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
                : letter
        })
        .join('')
}

export const cssVar = (variable: string, fallback?: string) => {
    const value = getComputedStyle(document.documentElement).getPropertyValue(variable)
    return value.length > 0 ? value : fallback ?? ''
}

export const applyTheme = (onSetTheme?: () => void): void => {
    const theme = getTheme()
    if (!theme.cssVariables) return
    const root = document.documentElement
    for (const property in quickswapTheme.cssVariables) {
        if (property === 'name') return
        root.style.setProperty(`--${kebabCase(property)}`, quickswapTheme.cssVariables[property])
    }
    onSetTheme?.()
}

export const isQuickswap = () => {
    const theme = getThemeName()
    return theme === 'quickswap'
}

export const getThemeName = () => {
    switch (window.location.host) {
        case 'quickswap.spritz.finance':
        case 'quickswap-staging.spritz.finance':
            // case 'localhost:3000':
            return 'quickswap'
        default:
            return 'spritz'
    }
}

export const getTheme = (): ThemePackage => {
    const themeName = getThemeName()
    switch (themeName) {
        case 'quickswap':
            return quickswapTheme
        default:
            return defaultTheme
    }
}

export const themedImage = (name: string, fallback?: string) => {
    const theme = getTheme()
    return theme.images?.[name] ? theme.images[name] : fallback
}
